module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"label_usos":"Tipo de uso / Solucion constructiva","titulo_evaluacion":"Evaluación del material","descrip_evaluacion":"En caso de querer proceder a la evaluación del material, seleccione el tipo uso de destino:","btn_evaluar":"Evaluar"}}')
  delete Component.options._Ctor
}
